// particles.js - lightweight particle bursts and screen shake for game "juice".
// Particles are plain data on game.particles; they're updated each frame and
// scrolled with the camera just like platforms/coins.

export const spawnBurst = (game, x, y, color, count = 12, speed = 4) => {
  if (!game.particles) game.particles = [];
  for (let i = 0; i < count; i++) {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.6;
    const spd = speed * (0.4 + Math.random() * 0.8);
    game.particles.push({
      x,
      y,
      vx: Math.cos(angle) * spd,
      vy: Math.sin(angle) * spd,
      life: 1,
      decay: 0.02 + Math.random() * 0.025,
      size: 2 + Math.random() * 2.5,
      color,
    });
  }
};

export const updateParticles = (game) => {
  if (!game.particles || game.particles.length === 0) return;
  game.particles = game.particles.filter((pt) => {
    pt.x += pt.vx;
    pt.y += pt.vy;
    pt.vy += 0.12; // gravity
    pt.vx *= 0.98;
    pt.life -= pt.decay;
    return pt.life > 0;
  });
};

export const drawParticles = (ctx, game) => {
  if (!game.particles || game.particles.length === 0) return;
  game.particles.forEach((pt) => {
    ctx.globalAlpha = Math.max(0, pt.life);
    ctx.fillStyle = pt.color;
    ctx.beginPath();
    ctx.arc(pt.x, pt.y, pt.size * pt.life, 0, Math.PI * 2);
    ctx.fill();
  });
  ctx.globalAlpha = 1;
};

export const triggerShake = (game, intensity = 8, frames = 18) => {
  game.shakeMag = intensity;
  game.shakeFrames = frames;
};
